import { useState, useEffect } from 'react';
import { getNotifications, markAsRead, markAllAsRead } from '../../services/notifications';
import { Bell, Megaphone, Medal, BookOpen, FileText, ScrollText } from 'lucide-react';

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNotifications().then(r => setNotifications(r.data?.data || r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleMarkAll = async () => {
    await markAllAsRead();
    setNotifications(ns => ns.map(n => ({ ...n, read_at: new Date().toISOString() })));
  };

  const handleMark = async (id) => {
    await markAsRead(id);
    setNotifications(ns => ns.map(n => n.id === id ? { ...n, read_at: new Date().toISOString() } : n));
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div></div>;

  const icons = { info: Megaphone, achievement: Medal, course: BookOpen, test: FileText, certificate: ScrollText };

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2"><Bell className="w-6 h-6" /> Bildirishnomalar</h1>
        <button onClick={handleMarkAll} className="text-sm text-blue-600 hover:text-blue-700 font-medium">Hammasini o'qilgan deb belgilash</button>
      </div>

      {notifications.length > 0 ? notifications.map(n => {
        const Icon = icons[n.type] || Bell;
        return (
        <div key={n.id} onClick={() => !n.read_at && handleMark(n.id)} className={`bg-white rounded-xl p-4 border cursor-pointer transition ${n.read_at ? 'border-gray-100' : 'border-blue-200 bg-blue-50/50'}`}>
          <div className="flex items-start gap-3">
            <Icon className="w-6 h-6 text-gray-500 flex-shrink-0" />
            <div className="flex-1">
              <h3 className={`text-sm font-medium ${n.read_at ? 'text-gray-700' : 'text-gray-900'}`}>{n.title}</h3>
              <p className="text-xs text-gray-500 mt-1">{new Date(n.created_at).toLocaleString('uz')}</p>
            </div>
            {!n.read_at && <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>}
          </div>
        </div>
        );
      }) : (
        <div className="bg-white rounded-2xl p-12 text-center border border-gray-100">
          <Bell className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500">Bildirishnomalar yo'q</p>
        </div>
      )}
    </div>
  );
}